import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";

const TargetSection = ({
  targetClearCount,
}: {
  targetClearCount: number;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_detail.section.target")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit/target"
        >
          {t("quest_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("quest_detail.field.target.target_clear_count"),
          children: (
            <Typography color="text.secondary">
              {t("quest_detail.field.target.target_clear_count_label", {
                count: targetClearCount.toLocaleString(),
              })}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default TargetSection;
